
const GENERIC_APP_LOADING = 'GENERIC_APP_LOADING';
const ADD_STICKY_NOTE = 'ADD_STICKY_NOTE';
const REMOVE_STICKY_NOTE = 'REMOVE_STICKY_NOTE';

const genericAppLoading = (id, isLoading) => {
    return {
        type: GENERIC_APP_LOADING,
        id,
        isLoading,
    };
}

const addStickyNote = (data) => {
    return {
        type: ADD_STICKY_NOTE, 
        data
    }
}

const removeStickyNote = (data) => {
    return {
        type: REMOVE_STICKY_NOTE, 
        data
    }
}

export default {
    types: {
        GENERIC_APP_LOADING,
        ADD_STICKY_NOTE,
        REMOVE_STICKY_NOTE
    },
    actions: {
        genericAppLoading,
        addStickyNote,
        removeStickyNote
    }
}
